import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UserDetailsService} from '../user-details.service';
import {DetailResultResponse1, UserGetDetail1, UserGetDetailDTO1, UserGetDTO1, UserGetRequest1} from 'msgm-api-lib';
import {UserDetailMessagePayloadPopupComponent} from '../user-detail-message-payload-popup/user-detail-message-payload-popup.component';
import {MatDialog} from '@angular/material';

@Component({
  selector: 'msgm-app-user-detail-outgoing-messages',
  templateUrl: './user-detail-outgoing-messages.component.html',
  styleUrls: ['./user-detail-outgoing-messages.component.scss']
})
export class UserDetailOutgoingMessagesComponent implements OnInit {
  public userGetDetailDTOs: UserGetDetailDTO1[];
  public offset = 0;
  public pageIndex = 0;

  private limit = 10;

  constructor(public userDetailsService: UserDetailsService, public activatedRoute: ActivatedRoute, public dialog: MatDialog) {
    activatedRoute.params.subscribe(params => {
      userDetailsService.subject = params['subject'];
      console.log('outgoing messages: changes in params: ', params);
    });
  }

  ngOnInit() {
    console.log('Triggering outgoing messages');
    const request: UserGetRequest1 = this._getUserGetRequest(this.userDetailsService.subject);
    this._fetchUserDetails(request);
  }

  private _fetchUserDetails(request: UserGetRequest1) {
    this.userDetailsService.getUserDetails(request).subscribe((response) => {
      const userGetDetails: UserGetDetail1[] = response.user_get_details;
      this.userGetDetailDTOs = this._getUserDetailDTOs(userGetDetails);
    });

  }

  private _getUserGetRequest(subject: string): UserGetRequest1 {
    const userGetDTO: UserGetDTO1 = {
      identity: {
        ia_subject: subject
      },
      outgoing_messages_filter: {
        limit: this.limit,
        offset: this.offset
      }
    };

    const userGetRequest: UserGetRequest1 = {
      user_get_dtos: [userGetDTO]
    };

    return userGetRequest;
  }

  private _getUserDetailDTOs(userGetDetails: UserGetDetail1[]): UserGetDetailDTO1[] {
    const successfullyProcessedUserDetailDTOs: UserGetDetailDTO1[] = [];

    for (let i = 0; i < userGetDetails.length; i++) {
      const userGetDetail: UserGetDetail1 = userGetDetails[i];
      const detailResultResponse: DetailResultResponse1 = userGetDetail.detail_result_response;

      if (detailResultResponse.result_state === 'WARNING') {
        console.warn('[UserDetails]: Warning while processing userGetDetail', detailResultResponse.result_message);
        this.offset = 0;
        continue;
      }

      if (detailResultResponse.result_state === 'ERROR') {
        console.warn('[UserDetails]: Error while processing userGetDetail', detailResultResponse.result_message);
        this.offset = 0;
        continue;
      }

      successfullyProcessedUserDetailDTOs.push(userGetDetail.user_create_detail_dto);
    }

    return successfullyProcessedUserDetailDTOs;
  }

  onClickShowPayload(element: any) {
    this.dialog.open(UserDetailMessagePayloadPopupComponent, {data: element});
  }

  onClickFilterOutgoingMessage(element: any) {
    this.offset = 0;
    const userGetDTO: UserGetDTO1 = {
      identity: {
        ia_subject: this.userDetailsService.subject
      },
      outgoing_messages_filter: {
        creation_interval: element,
        limit: this.limit,
        offset: this.offset
      }
    };

    const userGetRequest: UserGetRequest1 = {
      user_get_dtos: [userGetDTO]
    };
    this._fetchUserDetails(userGetRequest);
  }

  onClickNextMessages(element: any) {
    this.pageIndex = element.pageIndex;
    this.offset = element.pageIndex * 10;
    this.limit = element.pageSize;
    const request: UserGetRequest1 = this._getUserGetRequest(this.userDetailsService.subject);
    this._fetchUserDetails(request);
  }
}
